/* Tinselo 2.0 */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const T = window.T2 || {};
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (cents) => {
    try { return new Intl.NumberFormat(T.locale || 'en', { style: 'currency', currency: T.currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const disc = (cents) => cents - Math.floor(cents * (T.discount || 0) / 100);
  const priceHTML = (cents) => T.discount > 0
    ? `<span class="price"><span class="price__now">${fmt(disc(cents))}</span><s class="price__was"><span class="vh">Regular price </span>${fmt(cents)}</s></span>`
    : `<span class="price"><span class="price__now">${fmt(cents)}</span></span>`;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let lenis = null;

  /* ---------- page transitions ---------- */
  const reveal = () => requestAnimationFrame(() => html.classList.add('is-ready'));
  reveal();
  addEventListener('pageshow', (e) => { if (e.persisted) { html.classList.remove('is-leaving'); html.classList.add('is-ready'); } });
  const leave = (url) => {
    if (reduce) { location.href = url; return; }
    html.classList.add('is-leaving');
    setTimeout(() => { location.href = url; }, 430);
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.dataset.cartOpen !== undefined || a.dataset.searchOpen !== undefined) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    if (/^\/(checkout|cart\/|account)/.test(url.pathname)) return;
    e.preventDefault();
    leave(url.href);
  });

  /* ---------- overlays (menu, search, cart) ---------- */
  const scrim = $('[data-scrim]');
  let openLayer = null, lastFocus = null;
  const lock = (on) => { if (lenis) on ? lenis.stop() : lenis.start(); document.body.style.overflow = on ? 'hidden' : ''; };
  function openL(el, focusSel) {
    if (openLayer && openLayer !== el) closeL(openLayer, true);
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    if (el.matches('[data-drawer],[data-search]')) scrim.classList.add('is-on');
    lock(true);
    openLayer = el;
    setTimeout(() => { const f = focusSel ? $(focusSel, el) : $('button,a,input', el); f && f.focus({ preventScroll: true }); }, 60);
  }
  function closeL(el, silent) {
    el.classList.remove('is-open');
    scrim.classList.remove('is-on');
    setTimeout(() => { if (!el.classList.contains('is-open')) el.hidden = true; }, 560);
    if (!silent) { lock(false); lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true }); }
    if (openLayer === el) openLayer = null;
    if (el.id === 'mnav') { const b = $('[data-mnav-open]'); b && b.setAttribute('aria-expanded', 'false'); }
  }
  scrim && scrim.addEventListener('click', () => openLayer && closeL(openLayer));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { if (openLayer) closeL(openLayer); closeMega(); }
    if (e.key === 'Tab' && openLayer) {
      const f = $$('a[href],button:not([disabled]),input,select,textarea', openLayer).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', (e) => { const c = e.target.closest('[data-close]'); if (c && openLayer && openLayer.contains(c)) closeL(openLayer); });

  /* mobile menu */
  const mnav = $('[data-mnav]');
  const mbtn = $('[data-mnav-open]');
  mbtn && mnav && mbtn.addEventListener('click', () => {
    mbtn.setAttribute('aria-expanded', 'true');
    openL(mnav);
    if (window.gsap && !reduce) gsap.fromTo($$('.mnav__list li, .mnav__sub li', mnav), { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: .6, stagger: .045, ease: 'power3.out', delay: .1 });
  });

  /* mega menu */
  const mega = $('[data-mega]'), mtog = $('[data-mega-toggle]'), header = $('[data-header]');
  let megaTimer;
  function openMega() {
    if (!mega || mega.classList.contains('is-open')) return;
    mega.hidden = false;
    header && header.classList.remove('is-hidden'); html.classList.remove('hdr-hidden');
    requestAnimationFrame(() => mega.classList.add('is-open'));
    mtog.setAttribute('aria-expanded', 'true');
    if (window.gsap && !reduce) gsap.fromTo($$('.mega__item', mega), { y: 18, opacity: 0 }, { y: 0, opacity: 1, duration: .55, stagger: .05, ease: 'power3.out', delay: .12 });
    const first = $('.mega__link', mega); first && preview(first);
  }
  function closeMega() {
    if (!mega || !mega.classList.contains('is-open')) return;
    mega.classList.remove('is-open');
    mtog.setAttribute('aria-expanded', 'false');
    setTimeout(() => { if (!mega.classList.contains('is-open')) mega.hidden = true; }, 600);
  }
  let pvFlip = false;
  function preview(link) {
    const src = link.dataset.preview; if (!src) return;
    const a = $('[data-preview-a]', mega), b = $('[data-preview-b]', mega);
    const cur = pvFlip ? b : a, nxt = pvFlip ? a : b;
    if (cur.getAttribute('src') === src && cur.classList.contains('is-on')) return;
    nxt.hidden = false; nxt.src = src;
    const show = () => { nxt.classList.add('is-on'); cur.classList.remove('is-on'); pvFlip = !pvFlip; };
    nxt.complete ? show() : (nxt.onload = show);
    const bl = $('[data-preview-blurb]', mega); if (bl) bl.textContent = link.dataset.blurb || '';
  }
  if (mega && mtog) {
    mtog.addEventListener('click', () => mega.classList.contains('is-open') ? closeMega() : openMega());
    const enter = () => { clearTimeout(megaTimer); megaTimer = setTimeout(openMega, 120); };
    const leaveM = () => { clearTimeout(megaTimer); megaTimer = setTimeout(closeMega, 260); };
    if (matchMedia('(hover: hover)').matches) {
      mtog.addEventListener('pointerenter', enter);
      mtog.addEventListener('pointerleave', leaveM);
      mega.addEventListener('pointerenter', () => clearTimeout(megaTimer));
      mega.addEventListener('pointerleave', leaveM);
    }
    $$('.mega__link', mega).forEach((l) => { l.addEventListener('pointerenter', () => preview(l)); l.addEventListener('focus', () => preview(l)); });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-header]')) closeMega(); });
  }

  /* header hide on scroll down */
  let lastY = scrollY;
  const onScroll = () => {
    const y = scrollY;
    if (!header) return;
    const hide = y > 260 && y > lastY + 4 && !openLayer && !(mega && mega.classList.contains('is-open'));
    if (hide) { header.classList.add('is-hidden'); html.classList.add('hdr-hidden'); }
    else if (y < lastY - 4 || y < 260) { header.classList.remove('is-hidden'); html.classList.remove('hdr-hidden'); }
    lastY = y;
  };
  addEventListener('scroll', onScroll, { passive: true });

  /* ---------- search ---------- */
  const sheet = $('[data-search]');
  if (sheet) {
    const input = $('[data-q]', sheet), out = $('[data-results]', sheet), hint = out.innerHTML;
    document.addEventListener('click', (e) => { const t = e.target.closest('[data-search-open]'); if (!t) return; e.preventDefault(); if (openLayer === mnav) closeL(mnav, true); openL(sheet, '[data-q]'); });
    let st, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(st);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = hint; return; }
      st = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${T.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`, { signal: ctrl.signal });
          const j = await r.json();
          const ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          out.innerHTML = ps.length
            ? `<div class="sres">${ps.map((p) => `<a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}${p.image.includes('?') ? '&' : '?'}width=160" alt="" width="64" height="64">` : '<span></span>'}<span><span class="sres__t">${esc(p.title)}</span><span class="sres__p">${priceHTML(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('')}</div><a class="sres__all" href="${T.routes.search}?q=${encodeURIComponent(q)}&type=product">See all results for “${esc(q)}”</a>`
            : `<p class="sres__none">Nothing matches “${esc(q)}”. Try a shorter word, like “lights” or “mug”.</p>`;
        } catch (err) { if (err.name !== 'AbortError') out.innerHTML = '<p class="sres__none">Search is not responding. Press Enter to see full results.</p>'; }
      }, 180);
    });
  }

  /* ---------- cart ---------- */
  const drawer = $('[data-drawer]'), toastEl = $('[data-toast]');
  let tt;
  const toast = (m) => { if (!toastEl) return; toastEl.textContent = m; toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('is-on'), 2400); };
  function renderCart(c, newKey) {
    $$('[data-count]').forEach((n) => { if (n.textContent != c.item_count) { n.textContent = c.item_count; n.classList.remove('bump'); void n.offsetWidth; n.classList.add('bump'); } });
    if (!drawer) return;
    $('[data-count-label]', drawer).textContent = `(${c.item_count})`;
    $('[data-total]', drawer).textContent = fmt(c.total_price);
    const saved = c.original_total_price - c.total_price;
    $('[data-save-row]', drawer).hidden = !(saved > 0);
    $('[data-save]', drawer).textContent = fmt(saved);
    $('[data-checkout]', drawer).toggleAttribute('hidden', !c.item_count);
    $('[data-items]', drawer).innerHTML = c.items.length ? c.items.map((i) => `
      <div class="dl${i.key === newKey ? ' is-new' : ''}">
        <a href="${esc(i.url)}">${i.image ? `<img src="${esc(i.image)}${i.image.includes('?') ? '&' : '?'}width=160" alt="" width="76" height="76" loading="lazy">` : ''}</a>
        <div><a class="dl__t" href="${esc(i.url)}">${esc(i.product_title)}</a>${i.variant_title && !i.product_has_only_default_variant ? `<p class="dl__v">${esc(i.variant_title)}</p>` : ''}
          <div class="dl__q"><button type="button" data-line="${esc(i.key)}" data-qty="${i.quantity - 1}" aria-label="${i.quantity > 1 ? 'Decrease quantity' : 'Remove'}"><svg class="ico" viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button><span>${i.quantity}</span><button type="button" data-line="${esc(i.key)}" data-qty="${i.quantity + 1}" aria-label="Increase quantity"><svg class="ico" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button></div>
        </div>
        <div class="dl__p">${i.original_line_price > i.final_line_price ? `<s>${fmt(i.original_line_price)}</s>` : ''}${fmt(i.final_line_price)}</div>
      </div>`).join('')
      : `<div class="dempty"><p>Your cart is empty.</p><a class="btn btn--line" href="/collections/all">Shop all decorations</a></div>`;
  }
  const getCart = async () => { const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); renderCart(c); return c; };
  async function addToCart(items, btn) {
    btn && btn.classList.add('is-busy');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) { toast(j.description || 'This item could not be added.'); return; }
      const c = await (await fetch('/cart.js')).json();
      renderCart(c, j.items && j.items[0] && j.items[0].key);
      openL(drawer);
    } catch (e) { toast('Connection problem. Try again.'); }
    finally { btn && btn.classList.remove('is-busy'); }
  }
  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart([{ id: +add.dataset.add, quantity: 1 }], add); return; }
    const ln = e.target.closest('[data-line]');
    if (ln) {
      ln.disabled = true;
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: ln.dataset.line, quantity: +ln.dataset.qty }) });
      renderCart(await r.json());
      return;
    }
    const co = e.target.closest('[data-cart-open]');
    if (co && drawer) { e.preventDefault(); if (openLayer === mnav) closeL(mnav, true); openL(drawer); }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-ajax-add]');
    if (!f) return;
    e.preventDefault();
    const d = new FormData(f);
    addToCart([{ id: +d.get('id'), quantity: Math.max(1, +(d.get('quantity') || 1)) }], $('[data-atc]', f));
  });
  if (drawer) getCart().catch(() => {});

  /* ---------- product page ---------- */
  const pd = $('[data-product]');
  if (pd) {
    const vj = $('[data-variants]', pd);
    const variants = vj ? JSON.parse(vj.textContent) : [];
    const form = $('#pform', pd), vid = $('[data-vid]', pd), atc = $('[data-atc]', pd), atcLabel = $('[data-atc-label]', pd);
    const stage = $('[data-stage]', pd), slides = stage ? $$('.slide', stage) : [], thumbs = $$('[data-go]', pd);
    const curEl = $('[data-cur]', pd);
    const goTo = (i, smooth = true) => { if (!stage || !slides[i]) return; stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' }); };
    const curIdx = () => stage ? Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth)) : 0;
    if (stage) {
      let raf;
      stage.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = curIdx(); thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); if (curEl) curEl.textContent = i + 1; const t = thumbs[i]; t && t.parentElement.scrollTo({ left: t.offsetLeft - 60, behavior: 'smooth' }); }); }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(+t.dataset.go)));
      const prev = $('[data-prev]', pd), next = $('[data-next]', pd);
      prev && prev.addEventListener('click', () => goTo(Math.max(0, curIdx() - 1)));
      next && next.addEventListener('click', () => goTo(Math.min(slides.length - 1, curIdx() + 1)));
      stage.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, curIdx() + 1)); } if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, curIdx() - 1)); } });
    }
    const opts = $$('[data-opt]', pd);
    const selected = () => opts.map((o) => { const c = $('input:checked', o); return c ? c.value : null; });
    const update = () => {
      const sel = selected();
      opts.forEach((o, k) => { const lab = $('[data-optval]', o); if (lab) lab.textContent = sel[k] || ''; });
      // mark values that have no available variant given the other choices
      opts.forEach((o, k) => $$('.pill', o).forEach((p) => {
        const v = $('input', p).value;
        const ok = variants.some((x) => x.available && x.options.every((ov, j) => j === k ? ov === v : ov === sel[j]));
        p.classList.toggle('is-na', !ok);
      }));
      const v = variants.find((x) => x.options.every((ov, j) => ov === sel[j]));
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      vid.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      const pr = $('[data-price] .price', pd); if (pr) pr.outerHTML = priceHTML(v.price);
      const pm = $('[data-price-mini]', pd); if (pm) pm.innerHTML = priceHTML(v.price);
      const sb = $('[data-sticky-atc]', pd); if (sb) sb.disabled = !v.available;
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      if (v.media) { const i = slides.findIndex((s) => +s.dataset.media === v.media); if (i > -1) goTo(i); }
    };
    opts.forEach((o) => o.addEventListener('change', update));
    if (opts.length) update();
    $$('[data-step]', pd).forEach((b) => b.addEventListener('click', () => { const q = $('input[name=quantity]', pd); q.value = Math.max(1, (+q.value || 1) + +b.dataset.step); }));
    const sticky = $('[data-sticky]', pd), sbtn = $('[data-sticky-atc]', pd);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); sbtn.tabIndex = on ? 0 : -1; }).observe(atc);
      sbtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })));
    }
  }

  /* ---------- collection: sort + load more ---------- */
  const sort = $('[data-sort]');
  sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); leave(u.href); });
  document.addEventListener('click', async (e) => {
    const m = e.target.closest('[data-more]'); if (!m) return;
    m.classList.add('is-busy'); m.disabled = true;
    try {
      const doc = new DOMParser().parseFromString(await (await fetch(m.dataset.more)).text(), 'text/html');
      const grid = $('[data-grid]');
      $$('[data-grid] > .card', doc).forEach((c, k) => { c.classList.add('is-in'); c.style.animationDelay = k * 40 + 'ms'; grid.appendChild(c); });
      const nm = $('[data-more]', doc);
      if (nm) { m.dataset.more = nm.dataset.more; m.disabled = false; m.classList.remove('is-busy'); } else m.parentElement.remove();
    } catch (err) { location.href = m.dataset.more; }
  });

  /* ---------- home: product selection tabs ---------- */
  const edit = $('[data-edit]');
  if (edit) {
    const cards = $$('[data-edit-grid] .card', edit), none = $('[data-edit-none]', edit);
    $$('[data-tab]', edit).forEach((t) => t.addEventListener('click', () => {
      $$('[data-tab]', edit).forEach((x) => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t); });
      const h = t.dataset.tab; let n = 0;
      cards.forEach((c) => {
        const show = h === '*' || (' ' + c.dataset.c + ' ').includes(' ' + h + ' ');
        c.classList.toggle('is-out', !show); c.classList.remove('is-in');
        if (show) { void c.offsetWidth; c.classList.add('is-in'); c.style.animationDelay = (n++) * 35 + 'ms'; }
      });
      none.hidden = n > 0;
      window.ScrollTrigger && ScrollTrigger.refresh();
    }));
  }

  /* ---------- hero: garland ---------- */
  const garland = $('[data-garland]');
  const COLORS = ['#ffd27a', '#c8323f', '#fff1cf', '#e9a23b', '#ffd27a', '#f0d8a8'];
  let bulbs = [];
  function buildGarland() {
    if (!garland) return;
    const w = garland.clientWidth, h = garland.clientHeight;
    garland.setAttribute('viewBox', `0 0 ${w} ${h}`);
    const swags = w < 700 ? 2 : 3, sw = w / swags, sag = h * .62;
    let d = `M -10 ${h * .08}`;
    for (let i = 0; i < swags; i++) { const x0 = i * sw, x1 = x0 + sw; d += ` Q ${x0 + sw / 2} ${sag * 1.55} ${x1 + (i === swags - 1 ? 10 : 0)} ${h * .08}`; }
    const ns = 'http://www.w3.org/2000/svg';
    garland.innerHTML = `<defs><radialGradient id="glow"><stop offset="0" stop-color="#ffe3b0" stop-opacity=".9"/><stop offset=".4" stop-color="#ffcf7a" stop-opacity=".35"/><stop offset="1" stop-color="#ffcf7a" stop-opacity="0"/></radialGradient></defs><path class="wire" d="${d}"/><path class="wire2" d="${d}" transform="translate(0 2)"/>`;
    const path = garland.querySelector('.wire');
    const len = path.getTotalLength();
    const n = Math.max(8, Math.round(w / 68));
    bulbs = [];
    for (let i = 1; i < n; i++) {
      const L = (i / n) * len, p = path.getPointAtLength(L), p2 = path.getPointAtLength(Math.min(len, L + 1));
      const ang = Math.atan2(p2.y - p.y, p2.x - p.x) * 180 / Math.PI * .55 + (i % 2 ? 7 : -7);
      const g = document.createElementNS(ns, 'g');
      g.setAttribute('class', 'bulb');
      g.setAttribute('transform', `translate(${p.x} ${p.y}) rotate(${ang})`);
      const col = COLORS[i % COLORS.length];
      g.innerHTML = `<circle class="halo" cx="0" cy="20" r="30" fill="url(#glow)"/><rect class="cap" x="-3.5" y="0" width="7" height="8" rx="1.5"/><path class="glass" d="M0 7 C 7 9 8 18 5 24 C 3 28 -3 28 -5 24 C -8 18 -7 9 0 7 Z" fill="${col}"/>`;
      garland.appendChild(g);
      bulbs.push({ g, x: p.x, y: p.y + 20 });
    }
    return { path, len };
  }
  function lightGarland(geo, instant) {
    if (!geo) return;
    if (instant || reduce || !window.gsap) { bulbs.forEach((b) => b.g.classList.add('on')); return; }
    geo.path.style.strokeDasharray = geo.len; geo.path.style.strokeDashoffset = geo.len;
    gsap.to(geo.path, { strokeDashoffset: 0, duration: 1.4, ease: 'power2.inOut' });
    bulbs.forEach((b, i) => setTimeout(() => b.g.classList.add('on'), 700 + i * 70));
  }
  if (garland) {
    let geo = buildGarland(), rw = garland.clientWidth;
    const hero = $('[data-hero]');
    const start = () => lightGarland(geo, false);
    window.gsap ? start() : addEventListener('load', start, { once: true });
    addEventListener('resize', () => { if (Math.abs(garland.clientWidth - rw) > 40) { rw = garland.clientWidth; geo = buildGarland(); lightGarland(geo, true); } });
    if (hero && matchMedia('(hover: hover)').matches && !reduce) {
      let raf;
      hero.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = garland.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
          bulbs.forEach((b) => { const dd = Math.hypot(b.x - x, b.y - y); b.g.style.setProperty('--b', Math.max(0, 1 - dd / 220).toFixed(2)); });
        });
      });
      hero.addEventListener('pointerleave', () => bulbs.forEach((b) => b.g.style.setProperty('--b', 0)));
    }
  }

  /* hero window slideshow */
  const win = $('[data-window]');
  if (win) {
    const ws = $$('.ws', win), ct = $('[data-cap-title]', win), cp = $('[data-cap-price]', win);
    let k = 0, timer;
    const cap = () => { const a = ws[k]; if (!a) return; ct.textContent = a.dataset.title; cp.innerHTML = priceHTML(+a.dataset.price); };
    const show = (n) => { ws[k].classList.remove('is-on'); ws[k].tabIndex = -1; k = (n + ws.length) % ws.length; ws[k].classList.add('is-on'); ws[k].tabIndex = 0; cap(); };
    cap();
    if (ws.length > 1 && !reduce) {
      const play = () => { clearInterval(timer); timer = setInterval(() => show(k + 1), 4200); };
      play();
      win.addEventListener('pointerenter', () => clearInterval(timer));
      win.addEventListener('pointerleave', play);
      document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : play());
    }
  }

  /* ---------- GSAP: smooth scroll + scroll scenes ---------- */
  function initMotion() {
    if (!window.gsap || reduce) return;
    if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
    if (window.Lenis) {
      lenis = new Lenis({ lerp: .1, smoothWheel: true });
      T.lenis = lenis;
      if (window.ScrollTrigger) lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
      $$('a[href^="#"]').forEach((a) => { const id = a.getAttribute('href'); if (id.length > 1) a.addEventListener('click', (e) => { const t = $(id); if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -90 }); } }); });
    }
    /* hero headline */
    const h1 = $('[data-split]');
    if (h1) {
      h1.innerHTML = h1.textContent.trim().split(/\s+/).map((w) => `<span class="w"><span>${esc(w)}</span></span>`).join(' ');
      gsap.timeline({ defaults: { ease: 'power4.out' }, delay: .25 })
        .from($$('.w > span', h1), { yPercent: 110, duration: 1.1, stagger: .07 })
        .from('.hero__lede, .hero__acts, .hero__facts', { y: 24, opacity: 0, duration: .9, stagger: .1 }, '-=.7')
        .from('[data-window]', { opacity: 0, y: 40, scale: .96, duration: 1.3 }, .2);
    }
    if (!window.ScrollTrigger) return;
    /* rooms: horizontal scroll on desktop */
    const rooms = $('[data-rooms]'), track = $('[data-rooms-track]');
    if (rooms && track) {
      gsap.matchMedia().add('(min-width: 991px)', () => {
        const dist = () => Math.max(0, track.scrollWidth - innerWidth);
        if (dist() < 40) return;
        gsap.to(track, { x: () => -dist(), ease: 'none', scrollTrigger: { trigger: rooms, start: 'top top', end: () => '+=' + dist(), pin: true, scrub: .6, invalidateOnRefresh: true, anticipatePin: 1 } });
      });
    }
    /* spotlight parallax */
    const spot = $('.spot__img');
    if (spot) gsap.fromTo(spot, { yPercent: -8 }, { yPercent: 0, ease: 'none', scrollTrigger: { trigger: '.spot', start: 'top bottom', end: 'bottom top', scrub: true } });
    addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
  }
  if (document.readyState === 'complete' || window.gsap) initMotion();
  else addEventListener('DOMContentLoaded', initMotion, { once: true });
})();
